import { ModalContext } from 'app/app';
import axios from 'axios';
import { IconedButton } from 'components/IconedButton';
import { BlackButton } from 'components/black_button/blackbutton';
import { MoneyInput } from 'components/form/input/money';
import { SwitchGreen } from 'components/form/switch_green/switch_green';
import {
  Button,
  DateInput,
  EmailInput,
  Fieldset,
  Loader,
  NumberInput,
  PhoneInput,
  Select,
  TextInput,
  ViewContext,
} from 'components/lib';
import { UnlimitedCard } from 'components/unlimitedCard/card';
import {
  classOptions,
  limitAutoLiabilityOptions,
  limitTowingStorageOptions,
  trailerInterchangeLimitOptions,
  trailersBodytype,
  vehiclesBodytype,
} from 'data';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const progressive = false;

const stateOptions = [
  { value: 'Alabama', label: 'AL' },
  { value: 'Alaska', label: 'AK' },
  { value: 'Arizona', label: 'AZ' },
  { value: 'Arkansas', label: 'AR' },
  { value: 'California', label: 'CA' },
  { value: 'Colorado', label: 'CO' },
  { value: 'Connecticut', label: 'CT' },
  { value: 'Delaware', label: 'DE' },
  { value: 'Florida', label: 'FL' },
  { value: 'Georgia', label: 'GA' },
  { value: 'Hawaii', label: 'HI' },
  { value: 'Idaho', label: 'ID' },
  { value: 'Illinois', label: 'IL' },
  { value: 'Indiana', label: 'IN' },
  { value: 'Iowa', label: 'IA' },
  { value: 'Kansas', label: 'KS' },
  { value: 'Kentucky', label: 'KY' },
  { value: 'Louisiana', label: 'LA' },
  { value: 'Maine', label: 'ME' },
  { value: 'Maryland', label: 'MD' },
  { value: 'Massachusetts', label: 'MA' },
  { value: 'Michigan', label: 'MI' },
  { value: 'Minnesota', label: 'MN' },
  { value: 'Mississippi', label: 'MS' },
  { value: 'Missouri', label: 'MO' },
  { value: 'Montana', label: 'MT' },
  { value: 'Nebraska', label: 'NE' },
  { value: 'Nevada', label: 'NV' },
  { value: 'New Hampshire', label: 'NH' },
  { value: 'New Jersey', label: 'NJ' },
  { value: 'New Mexico', label: 'NM' },
  { value: 'New York', label: 'NY' },
  { value: 'North Carolina', label: 'NC' },
  { value: 'North Dakota', label: 'ND' },
  { value: 'Ohio', label: 'OH' },
  { value: 'Oklahoma', label: 'OK' },
  { value: 'Oregon', label: 'OR' },
  { value: 'Pennsylvania', label: 'PA' },
  { value: 'Rhode Island', label: 'RI' },
  { value: 'South Carolina', label: 'SC' },
  { value: 'South Dakota', label: 'SD' },
  { value: 'Tennessee', label: 'TN' },
  { value: 'Texas', label: 'TX' },
  { value: 'Utah', label: 'UT' },
  { value: 'Vermont', label: 'VT' },
  { value: 'Virginia', label: 'VA' },
  { value: 'Washington', label: 'WA' },
  { value: 'West Virginia', label: 'WV' },
  { value: 'Wisconsin', label: 'WI' },
  { value: 'Wyoming', label: 'WY' },
];

function getClassIndex(classKey) {
  switch (classKey) {
    case '1':
      return '1';
    case '2a':
      return '2a';
    case '2b':
      return '2b';
    case '3':
      return '4';
    case '4':
      return '5';
    case '5':
      return '6';
    case '6':
      return '7';
    case '7':
      return '8';
    case '8':
      return '9';
    default:
      return '1';
  }
}

function getClass(classKey) {
  switch (classKey) {
    case '1':
      return '1';
    case '2a':
      return '2a';
    case '2b':
      return '2b';
    case '4':
      return '3';
    case '5':
      return '4';
    case '6':
      return '5';
    case '7':
      return '6';
    case '8':
      return '7';
    case '9':
      return '8';
    default:
      return '1';
  }
}

export function RunEndorsemenet(props) {
  const context = useContext(ViewContext);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [data, setData] = useState({
    producer: [],
    commodityArray: [],
    vehicles: [],
    trailers: [],
    drivers: [],
  });

  useEffect(() => {
    if (
      location.state &&
      location.state.data &&
      location.state.data.company_id
    ) {
      if (location.state.data.quote_id) {
        setLoading(true);

        axios
          .get('/api/quote/' + location.state.data.quote_id)
          .then(async (r) => {
            const quoteData = r.data.data.quote;

            quoteData.generalLiability = [];
            quoteData.operationDescription = [];
            quoteData.commodityArray = quoteData.commodities;
            delete quoteData.commodities;

            //Coverages

            if (quoteData.coverage.requestApd === 'Y') {
              quoteData.generalLiability.push(
                'Automobile Physical Damage (APD)'
              );
            }

            if (quoteData.coverage.requestMtc === 'Y') {
              quoteData.generalLiability.push(
                'Motor Truck Cargo (MTC)'
              );
            }

            if (quoteData.coverage.requestTgl === 'Y') {
              quoteData.generalLiability.push(
                'Truckers General Liability (TGL)'
              );
            }

            if (quoteData.coverage.requestNtl === 'Y') {
              quoteData.generalLiability.push(
                'Non-Trucking Liability (NTL)'
              );
            }

            //Operation Description

            if (quoteData.operations.opsLocal === 'Y') {
              quoteData.operationDescription.push('Local trucker');
            }

            if (quoteData.operations.opsHouseholdGoods === 'Y') {
              quoteData.operationDescription.push(
                'Household goods mover'
              );
            }

            if (quoteData.operations.opsAutomobileHauler === 'Y') {
              quoteData.operationDescription.push(
                'Automobile hauler [Excluded for cargo and NTL]'
              );
            }

            if (quoteData.operations.opsOversizedOvernight === 'Y') {
              quoteData.operationDescription.push(
                'Oversized or overweight'
              );
            }

            if (quoteData.operations.opsHotShot === 'Y') {
              quoteData.operationDescription.push(
                'Hot shot (TGL and NTL not available for  class 3 vehicles)'
              );
            }

            if (quoteData.operations.opsRefrigirated === 'Y') {
              quoteData.operationDescription.push(
                'refrigerated trailer'
              );
            }

            if (quoteData.operations.opsLogging === 'Y') {
              quoteData.operationDescription.push('Logging');
            }

            if (quoteData.operations.opsEndDumper === 'Y') {
              quoteData.operationDescription.push('End dumper units');
            }

            if (quoteData.operations.opsDumpTruckSandGravel === 'Y') {
              quoteData.operationDescription.push(
                'Dump trucks (sand and gravel)'
              );
            }

            if (quoteData.operations.opsDumpTruckOther === 'Y') {
              quoteData.operationDescription.push(
                'Dump trucks (Other)'
              );
            }

            if (quoteData.operations.opsTanker === 'Y') {
              quoteData.operationDescription.push('Tankers');
            }

            if (quoteData.operations.opsHouseholdGoods === 'Y') {
              quoteData.operationDescription.push(
                'Household goods mover'
              );
            }

            if (quoteData.operations.opsIntermodalPort === 'Y') {
              quoteData.operationDescription.push(
                'Intermodal or port'
              );
            }

            if (quoteData.operations.opsLongHaul === 'Y') {
              quoteData.operationDescription.push(
                'Long haul trucker'
              );
            }

            if (quoteData.operations.opsIntermediate === 'Y') {
              quoteData.operationDescription.push('Intermediate');
            }

            const formattedDrivers = [];
            const formattedVehicles = [];

            quoteData.drivers.forEach((value, index) => {
              const driver = value;

              driver.licenseState = stateOptions.find(
                (item) => item.label === value.licenseState
              )
                ? stateOptions.find(
                    (item) => item.label === value.licenseState
                  ).value
                : stateOptions.find(
                    (item) => item.value === value.licenseState
                  ).value;

              if (driver.violations_total) {
                driver.violations = driver.violations_total;
              }

              if (driver.suspensions_total) {
                driver.suspensions = driver.suspensions_total;
              }

              if (driver.accidents_total) {
                driver.accidents = driver.accidents_total;
              }

              formattedDrivers.push(driver);
            });

            for (var i = 0; i < quoteData.vehicles.length; i++) {
              const value = quoteData.vehicles[i];

              delete value.class;

              formattedVehicles.push({
                ...value,
              });
            }

            setData((prevState) => {
              return {
                ...prevState,
                requestAl: quoteData.coverage.requestAl === 'Y' && [
                  'Auto Liability (AL)',
                ],
                optAlPip: quoteData.coverage.requestAl === 'Y' && [
                  'Personal Injury Protection (PIP)',
                ],
                optAlUm: quoteData.coverage.requestAl === 'Y' && [
                  'Uninsured Motorists/Property Damage',
                ],
                generalLiability: quoteData.generalLiability,
                effectiveDate:
                  quoteData.coverage.effectiveDate.split('/')[2] +
                  '-' +
                  quoteData.coverage.effectiveDate.split('/')[0] +
                  '-' +
                  quoteData.coverage.effectiveDate.split('/')[1],
                dotNumber: quoteData.insuredInformation.dotNumber,
                legalName: quoteData.insuredInformation.legalName,
                dbaName: quoteData.insuredInformation.dbaName,
                ownerName: quoteData.insuredInformation.ownerName,
                mailingStreet: quoteData.mailingAddress.mailingStreet,
                mailingStreet2:
                  quoteData.mailingAddress.mailingStreet2,
                mailingCity: quoteData.mailingAddress.mailingCity,
                mailingCountry:
                  quoteData.mailingAddress.mailingCountry,
                mailingCounty: quoteData.mailingAddress.mailingCounty,
                mailingState: stateOptions.find(
                  (item) =>
                    item.label ===
                    quoteData.mailingAddress.mailingState
                )
                  ? stateOptions.find(
                      (item) =>
                        item.label ===
                        quoteData.mailingAddress.mailingState
                    ).value
                  : stateOptions[0],
                mailingZip: quoteData.mailingAddress.mailingZip,
                garageStreet: quoteData.garageAddress.garageStreet,
                garageStreet2: quoteData.garageAddress.garageStreet2,
                garageCity: quoteData.garageAddress.garageCity,
                garageCountry: quoteData.garageAddress.garageCountry,
                garageCounty: quoteData.garageAddress.garageCounty,
                garageState: stateOptions.find(
                  (item) =>
                    item.label === quoteData.garageAddress.garageState
                )
                  ? stateOptions.find(
                      (item) =>
                        item.label ===
                        quoteData.garageAddress.garageState
                    ).value
                  : stateOptions[0],
                garageZip: quoteData.garageAddress.garageZip,
                insuranceContactFirstName:
                  quoteData.insuredInformation
                    .insuranceContactFirstName,
                insuranceContactLastName:
                  quoteData.insuredInformation
                    .insuranceContactLastName,
                insuranceContactEmail:
                  quoteData.insuredInformation.insuranceContactEmail,
                insuranceContactPhone:
                  quoteData.insuredInformation.insuranceContactPhone,
                entityType: quoteData.insuredInformation.entityType,
                limitTowingStorage: limitTowingStorageOptions.find(
                  (item) =>
                    item.value === quoteData.limits.limitTowingStorage
                )
                  ? limitTowingStorageOptions.find(
                      (item) =>
                        item.value ===
                        quoteData.limits.limitTowingStorage
                    ).value
                  : limitTowingStorageOptions[0].value,
                trailerInterchangeLimit:
                  trailerInterchangeLimitOptions.find(
                    (item) =>
                      item.value ===
                      quoteData.limits.trailerInterchangeLimit
                  )
                    ? trailerInterchangeLimitOptions.find(
                        (item) =>
                          item.value ===
                          quoteData.limits.trailerInterchangeLimit
                      ).value
                    : null,
                limitAutoLiability: limitAutoLiabilityOptions.find(
                  (item) =>
                    item.value === quoteData.limits.limitAutoLiability
                )
                  ? limitAutoLiabilityOptions.find(
                      (item) =>
                        item.value ===
                        quoteData.limits.limitAutoLiability
                    ).value
                  : limitAutoLiabilityOptions[0],
                filingsAlState:
                  quoteData.operations.filingsAlFederal === 'Y'
                    ? true
                    : false,
                filingsAlFederal:
                  quoteData.operations.filingsAlFederal === 'Y'
                    ? true
                    : false,
                dataSharingOption:
                  quoteData.operations.dataSharingOption,
                eldVendorName: quoteData.operations.eldVendorName,
                bankruptcies:
                  quoteData.operations.bankruptcies === 'Y'
                    ? true
                    : false,
                personalUseOfVehicle:
                  quoteData.operations.personalUseOfVehicle === 'Y'
                    ? true
                    : false,
                UIIAintermodal:
                  quoteData.operations.UIIAintermodal === 'Y'
                    ? true
                    : false,
                priorInsuranceCancelledNonrenewed:
                  quoteData.operations
                    .priorInsuranceCancelledNonrenewed === 'Y'
                    ? true
                    : false,
                yearsInBusiness:
                  quoteData.insuredInformation.yearsInBusiness,
                monthsInBusiness:
                  quoteData.insuredInformation.monthsInBusiness,
                ineligibleOperations:
                  quoteData.operations.ineligibleOperations === 'Y'
                    ? true
                    : false,
                operationDescription: quoteData.operationDescription,
                radius0_50: quoteData.radius.radius0_50
                  ? quoteData.radius.radius0_50
                  : 0,
                radius51_200: quoteData.radius.radius51_200
                  ? quoteData.radius.radius51_200
                  : 0,
                radius201_500: quoteData.radius.radius201_500
                  ? quoteData.radius.radius201_500
                  : 0,
                radius501: quoteData.radius.radius501
                  ? quoteData.radius.radius501
                  : 0,
                commoditiesRefrigeration:
                  quoteData.commoditiesRefrigeration === 'Y'
                    ? true
                    : false,
                commodityArray: quoteData.commodityArray,
                mtcLimit: quoteData.limits.mtcLimit,
                nbrOfTrucks: quoteData.vehicles.length,
                valueOfTrucks: quoteData.limits.valueOfTrucks,
                vehicles: formattedVehicles,
                nbrOfTrailers: quoteData.trailers.length,
                valueOfTrailers: quoteData.limits.valueOfTrailers,
                trailers: quoteData.trailers,
                drivers: formattedDrivers,
                insuredWaiverSubrogation:
                  quoteData.limits.insuredWaiverSubrogation === 'Y'
                    ? true
                    : false,
                primaryNoncontributoryTGL:
                  quoteData.limits.primaryNoncontributoryTGL === 'Y'
                    ? true
                    : false,
                primaryNoncontributoryAL:
                  quoteData.limits.primaryNoncontributoryAL === 'Y'
                    ? true
                    : false,
                lossConfirmed:
                  quoteData.losses[1].lossConfirmed === 'Y'
                    ? true
                    : false,
                lossAlCount1: quoteData.losses[1].lossAlCount,
                lossAlPaid1: quoteData.losses[1].lossAlPaid,
                lossApdCount1: quoteData.losses[1].lossApdCount,
                lossApdPaid1: quoteData.losses[1].lossApdPaid,
                lossMtcCount1: quoteData.losses[1].lossMtcCount,
                lossMtcPaid1: quoteData.losses[1].lossMtcPaid,
                lossTglCount1: quoteData.losses[1].lossTglCount,
                lossTglPaid1: quoteData.losses[1].lossTglPaid,
                lossNtlCount1: quoteData.losses[1].lossNtlCount,
                lossNtlPaid1: quoteData.losses[1].lossNtlPaid,
                lossAlCount2: quoteData.losses[2].lossAlCount,
                lossAlPaid2: quoteData.losses[2].lossAlPaid,
                lossApdCount2: quoteData.losses[2].lossApdCount,
                lossApdPaid2: quoteData.losses[2].lossApdPaid,
                lossMtcCount2: quoteData.losses[2].lossMtcCount,
                lossMtcPaid2: quoteData.losses[2].lossMtcPaid,
                lossTglCount2: quoteData.losses[2].lossTglCount,
                lossTglPaid2: quoteData.losses[2].lossTglPaid,
                lossNtlCount2: quoteData.losses[2].lossNtlCount,
                lossNtlPaid2: quoteData.losses[2].lossNtlPaid,
                lossAlCount3: quoteData.losses[3].lossAlCount,
                lossAlPaid3: quoteData.losses[3].lossAlPaid,
                lossApdCount3: quoteData.losses[3].lossApdCount,
                lossApdPaid3: quoteData.losses[3].lossApdPaid,
                lossMtcCount3: quoteData.losses[3].lossMtcCount,
                lossMtcPaid3: quoteData.losses[3].lossMtcPaid,
                lossTglCount3: quoteData.losses[3].lossTglCount,
                lossTglPaid3: quoteData.losses[3].lossTglPaid,
                lossNtlCount3: quoteData.losses[3].lossNtlCount,
                lossNtlPaid3: quoteData.losses[3].lossNtlPaid,
              };
            });

            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);

            context.notification.show(
              'Error on load company data',
              'error',
              true
            );
          });
      } else {
        setLoading(true);

        axios
          .get('/api/company/' + location.state.data.company_id)
          .then(async (r) => {
            const today = new Date().toJSON().slice(0, 10);
            setLoading(false);

            setData({
              ...data,
              effectiveDate: data.effectiveDate
                ? data.effectiveDate
                : today,
              commodityArray: [],
              dotNumber: r.data.data.dot_number,
              legalName: r.data.data.name,
              dbaName: r.data.data.dba_name,
              ownerName: r.data.data.owner_name,
              mailingStreet: r.data.data.address,
              mailingStreet2: r.data.data.address2,
              mailingCity: r.data.data.city,
              mailingState: r.data.data.state
                ? r.data.data.state
                : stateOptions[0],
              mailingZip: r.data.data.zip,
              garageStreet: '',
              garageState: r.data.data.state
                ? r.data.data.state
                : stateOptions[0],
              garageCity: '',
              garageZip: '',
              insuranceContactFirstName:
                r.data.data.owner_name.split(' ')[0],
              insuranceContactLastName:
                r.data.data.owner_name.split(' ')[1],
              insuranceContactEmail: r.data.data.email,
              insuranceContactPhone: r.data.data.phone,
              yearsInBusiness: r.data.data.years_in_business,
              entityType: '',
              dataSharingOption: '',
              limitTowingStorage: '',
              limitAutoLiability: '',
              mtcLimit: '',
              lossConfirmed: true,
            });
          })
          .catch((err) => {
            setLoading(false);

            console.log(err);

            context.notification.show(
              'Error on load company data',
              'error',
              true
            );
          });
      }
    }
  }, [location]);

  const onChange = (name, value) => {
    if (name !== 'sameBusinessAddress') {
      setData((prevState) => {
        return {
          ...prevState,
          [name]: value,
        };
      });
      return;
    }

    if (value.length) {
      const copyData = { ...data };
      setData((prevState) => {
        return {
          ...prevState,
          [name]: value,
          garageStreet: copyData.mailingStreet,
          garageStreet2: copyData.mailingStreet2,
          garageCity: copyData.mailingCity,
          garageState: copyData.mailingState,
          garageZip: copyData.mailingZip,
        };
      });
    } else {
      setData((prevState) => {
        return {
          ...prevState,
          [name]: value,
          garageStreet: '',
          garageStreet2: '',
          garageCity: '',
          garageState: '',
          garageZip: '',
        };
      });
    }
  };

  const handleSubmit = async () => {
    setSubmitLoading(true);

    const postData = {
      quote_id: location.state.data.quote_id,
      UIIAintermodal: data.UIIAintermodal,
      coverage: {
        requestAl: data.requestAl?.length > 0 ? 'Y' : 'N',
        optAlPip: data.optAlPip?.length > 0 ? 'Y' : 'N',
        optAlUm: data.optAlUm?.length > 0 ? 'Y' : 'N',
        requestApd: data.generalLiability?.includes(
          'Automobile Physical Damage (APD)'
        )
          ? 'Y'
          : 'N',
        requestMtc: data.generalLiability?.includes(
          'Motor Truck Cargo (MTC)'
        )
          ? 'Y'
          : 'N',
        requestTgl: data.generalLiability?.includes(
          'Truckers General Liability (TGL)'
        )
          ? 'Y'
          : 'N',
        requestNtl: data.generalLiability?.includes(
          'Non-Trucking Liability (NTL)'
        )
          ? 'Y'
          : 'N',
        effectiveDate:
          data.effectiveDate.split('-')[1] +
          '/' +
          data.effectiveDate.split('-')[2] +
          '/' +
          data.effectiveDate.split('-')[0],
      },
      insuredInformation: {
        email: data.insuranceContactEmail,
        insuranceContactPhone: data.insuranceContactPhone,
        insuranceContactEmail: data.insuranceContactEmail,
      },
      limits: {
        trailerInterchange: data.generalLiability.includes(
          'Trailer Interchange'
        )
          ? 'Y'
          : 'N',
        trailerInterchangeLimit: data.trailerInterchangeLimit,
        limitTowingStorage: data.limitTowingStorage,
        nbrOfTrucks: data.nbrOfTrucks,
        valueOfTrucks: data.valueOfTrucks,
        nbrOfTrailers: data.nbrOfTrailers,
        valueOfTrailers: data.valueOfTrailers,
        limitAutoLiability: data.limitAutoLiability,
        mtcLimit: data.mtcLimit,
        insuredWaiverSubrogation: data.insuredWaiverSubrogation
          ? 'Y'
          : 'N',
        primaryNoncontributoryTGL: data.primaryNoncontributoryTGL
          ? 'Y'
          : 'N',
        primaryNoncontributoryAL: data.primaryNoncontributoryAL
          ? 'Y'
          : 'N',
      },
      garageAddress: {
        garageStreet: data.garageStreet,
        garageStreet2: data.garageStreet2,
        garageCity: data.garageCity,
        garageState: stateOptions.find(
          (item) => item.value === data.garageState
        )
          ? stateOptions.find(
              (item) => item.value === data.garageState
            ).label
          : stateOptions.find(
              (item) => item.label === data.garageState
            ).label,
        garageZip: data.garageZip,
        garageCounty: 'County',
        garageCountry: 'USA',
      },
      mailingAddress: {
        mailingStreet: data.mailingStreet,
        mailingStreet2: data.mailingStreet2,
        mailingCity: data.mailingCity,
        mailingState: stateOptions.find(
          (item) => item.value === data.mailingState
        )
          ? stateOptions.find(
              (item) => item.value === data.mailingState
            ).label
          : stateOptions.find(
              (item) => item.label === data.mailingState
            ).label,
        mailingZip: data.mailingZip,
        mailingCounty: 'County',
        mailingCountry: 'USA',
      },
      vehicles: data.vehicles,
      trailers: data.trailers,
      drivers: data.drivers.map((driver) => {
        return {
          ...driver,
          licenseState: stateOptions.find(
            (state) => state.value === driver.licenseState
          )
            ? stateOptions.find(
                (state) => state.value === driver.licenseState
              ).label
            : stateOptions.find(
                (state) => state.label === driver.licenseState
              ).label,
        };
      }),
      other: data.other,
    };

    await axios
      .post('/api/endorsement/submit', postData)
      .then((r) => {
        context.notification.show(
          'Endorsement sended successfully',
          'success',
          true
        );
        setSubmitLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 406) {
          context.notification.show(
            err.response.data.message,
            'error',
            true
          );
        }

        setSubmitLoading(false);
      });
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div>
            <Coverages onChange={onChange} data={data} />
            <Limits onChange={onChange} data={data} />
            <Insured onChange={onChange} data={data} />
            <Operations onChange={onChange} data={data} />
            <Vehicles data={data} setData={setData} />
            <Trailers data={data} setData={setData} />
            <Drivers data={data} setData={setData} />
            <Other onChange={onChange} data={data} />
            <div className="flex gap-4">
              <Button
                text="Submit Endorsement"
                color="bluesign"
                className="w-full mt-4"
                action={!submitLoading ? handleSubmit : null}
                loading={submitLoading}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
}

function Coverages(props) {
  const data = props.data;
  const onChange = props.onChange;

  return (
    <UnlimitedCard className="mb-4" id="1">
      <header className="w-full pb-4 mb-4 bg-transparent border-b-2 border-slate-300">
        <h2 className="capitalize text-xl font-semibold pt-4">
          Coverages (Select coverages to quote)
        </h2>
      </header>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
          <Fieldset
            name="requestAl"
            type="checkbox"
            options={['Auto Liability (AL)']}
            cols={1}
            default={data.requestAl}
            className="font-bold w-[32%]"
            onChange={onChange}
          />
          {data.requestAl?.[0] === 'Auto Liability (AL)' && (
            <>
              <Fieldset
                name="optAlPip"
                type="checkbox"
                options={['Personal Injury Protection (PIP)']}
                cols={1}
                default={data.optAlPip}
                className="font-bold w-[32%]"
                onChange={onChange}
              />
              <Fieldset
                name="optAlUm"
                type="checkbox"
                options={['Uninsured Motorists/Property Damage']}
                cols={1}
                default={data.optAlUm}
                className="font-bold w-[32%]"
                onChange={onChange}
              />
            </>
          )}
        </div>
        <Fieldset
          name="generalLiability"
          type="checkbox"
          options={[
            'Automobile Physical Damage (APD)',
            'Motor Truck Cargo (MTC)',
            'Truckers General Liability (TGL)',
            'Non-Trucking Liability (NTL)',
            'Trailer Interchange',
          ]}
          cols={1}
          default={data.generalLiability}
          className="font-bold"
          onChange={onChange}
        />
      </div>
      <div style={{ marginTop: 10 }}>
        <p className="m-0">
          <strong>Policy Effective Date</strong>
        </p>
        <DateInput
          name="effectiveDate"
          className="w-full"
          onChange={onChange}
          calendarPosition="left"
          value={data.effectiveDate}
        />
      </div>
    </UnlimitedCard>
  );
}

function Limits(props) {
  const data = props.data;
  const onChange = props.onChange;

  return (
    <UnlimitedCard className="mb-6" id="4">
      <header className="w-full pb-4 mb-4 bg-transparent border-b-2 border-slate-300">
        <h2 className="capitalize text-xl font-semibold pt-4">
          Limits
        </h2>
      </header>
      <SwitchGreen
        name="insuredWaiverSubrogation"
        label="Do you need Waiver Subrogation?"
        labelRight
        labelClassName="font-bold w-[85%]"
        className="my-4"
        onChange={onChange}
        default={data.insuredWaiverSubrogation}
      />
      {data.generalLiability?.includes(
        'Truckers General Liability (TGL)'
      ) && (
        <SwitchGreen
          name="primaryNoncontributoryTGL"
          label="Do you need Primary and Noncontributory for TGL?"
          labelRight
          labelClassName="font-bold w-[85%]"
          className="my-4"
          onChange={onChange}
          default={data.primaryNoncontributoryTGL}
        />
      )}
      {data.requestAl?.length > 0 && (
        <SwitchGreen
          name="primaryNoncontributoryAL"
          label="Do you need Primary and Noncontributory for AL?"
          labelRight
          labelClassName="font-bold w-[85%]"
          className="my-4"
          onChange={onChange}
          default={data.primaryNoncontributoryAL}
        />
      )}

      <div className="flex justify-between flex-wrap w-full gap-4">
        <div className="w-[49%]">
          <p className="m-0">
            <strong>Towing, Labor and Storage Limit</strong>
          </p>
          <Select
            name="limitTowingStorage"
            options={limitTowingStorageOptions}
            onChange={onChange}
            value={data.limitTowingStorage}
            default={data.limitTowingStorage}
          />
        </div>
        {data.requestAl?.length > 0 && (
          <div className="w-[49%]">
            <p className="m-0">
              <strong>Auto Liability Limit</strong>
            </p>
            <Select
              name="limitAutoLiability"
              options={limitAutoLiabilityOptions}
              onChange={onChange}
              default={data.limitAutoLiability}
              value={data.limitAutoLiability}
            />
          </div>
        )}

        <div className="w-[49%]">
          <p className="m-0">
            <strong>Limit-Motor Truck Cargo</strong>
          </p>
          <Select
            name="mtcLimit"
            id="mtcLimit"
            value={data.mtcLimit}
            default={data.mtcLimit}
            options={[
              { value: '0', label: 'No, Excluded' },
              { value: '100000', label: '$ 100,000' },
              { value: '125000', label: '$ 125,000' },
              { value: '150000', label: '$ 150,000' },
              { value: '175000', label: '$ 175,000' },
              { value: '200000', label: '$ 200,000' },
              { value: '250000', label: '$ 250,000' },
            ]}
            containerClass="m-0"
            onChange={onChange}
          />
        </div>
        {data.generalLiability &&
          data.generalLiability.includes('Trailer Interchange') && (
            <div className="w-[49%]">
              <p className="m-0">
                <strong>Trailer Interchange Limit</strong>
              </p>
              <Select
                name="trailerInterchangeLimit"
                options={trailerInterchangeLimitOptions}
                onChange={onChange}
                default={data.trailerInterchangeLimit}
                value={data.trailerInterchangeLimit}
              />
              <p className="text-sm">
                This coverage requieres a signed interchange agreement
              </p>
            </div>
          )}
      </div>
    </UnlimitedCard>
  );
}

function Operations(props) {
  const data = props.data;
  const onChange = props.onChange;

  return (
    <UnlimitedCard className="mb-6" id="5">
      <header className="w-full pb-4 mb-4 bg-transparent border-b-2 border-slate-300 flex items-center pt-4">
        <h2 className="capitalize text-xl font-semibold w-1/2">
          Operations
        </h2>
      </header>
      <SwitchGreen
        name="UIIAintermodal"
        label="UIIA Intermodal?"
        labelRight
        labelClassName="font-bold"
        className="my-8"
        onChange={onChange}
        default={data.UIIAintermodal}
      />
    </UnlimitedCard>
  );
}

function Other(props) {
  const data = props.data;
  const onChange = props.onChange;

  return (
    <UnlimitedCard className="mb-4" id="1">
      <header className="w-full pb-4 mb-4 bg-transparent border-b-2 border-slate-300">
        <h2 className="capitalize text-xl font-semibold pt-4">
          Other (Explain what you need done)
        </h2>
      </header>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <textarea
          name="other"
          id="other"
          rows={10}
          className="border-2 pl-4 pt-4"
          onChange={(e) => {
            onChange('other', e.target.value);
          }}
          value={data.other}
        />
      </div>
    </UnlimitedCard>
  );
}

function Insured(props) {
  const data = props.data;
  const onChange = props.onChange;
  const context = useContext(ViewContext);

  const aditionalInsuredInfo = () => {
    context.modal.show(
      {
        title: 'Additional insured info',
        form: {
          aditionalInsuredInfoName: {
            id: 'aditionalInsuredInfoName',
            label: 'Name',
            type: 'text',
            class: 'w-full',
            containerClass: 'w-full',
            required: true,
          },
          aditionalInsuredInfoAddress: {
            id: 'aditionalInsuredInfoAddress',
            label: 'Address',
            type: 'text',
            class: 'w-full',
            containerClass: 'w-full',
            required: true,
          },
          aditionalInsuredInfoCity: {
            id: 'aditionalInsuredInfoCity',
            label: 'City',
            type: 'text',
            class: 'w-full',
            containerClass: 'w-[49%]',
            required: true,
          },
          aditionalInsuredInfoState: {
            label: 'State',
            type: 'select',
            options: [],
            class: 'w-full',
            containerClass: 'w-[22%]',
            required: true,
          },
          aditionalInsuredInfoZIP: {
            id: 'aditionalInsuredInfoZIP',
            label: 'ZIP',
            type: 'text',
            class: 'w-full',
            containerClass: 'w-[22%]',
            required: true,
          },
        },
        className: 'flex flex-wrap justify-between',
        buttonText: 'Save',
        buttonClass: 'flex justify-end w-full mt-4',
      },
      (res) => {
        console.log(res);
      }
    );
  };

  return (
    <UnlimitedCard className="mb-4" id="2">
      <header className="w-full pb-4 mb-4 bg-transparent border-b-2 border-slate-300 flex justify-between">
        <h2 className="capitalize text-xl font-semibold pt-4">
          Insured
        </h2>
        {progressive && (
          <Button
            color="bluesign"
            size={16}
            text="Add additional insured"
            className="p-2 text-white rounded"
            action={aditionalInsuredInfo}
          />
        )}
      </header>

      <div className="border rounded p-4 mt-2 mb-8">
        <p className="text-xl">
          <strong>Mailing address</strong>
        </p>
        <div className="flex justify-between w-full">
          <div className="w-[28%]">
            <p className="m-0" style={{ marginBottom: 10 }}>
              <strong>Address</strong>
            </p>
            <TextInput
              name="mailingStreet"
              id="mailingStreet"
              className="w-full"
              onChange={onChange}
              value={data.mailingStreet}
            />
          </div>
          <div className="w-[28%]">
            <p className="m-0" style={{ marginBottom: 10 }}>
              <strong>Address Line 2</strong>
            </p>
            <TextInput
              name="mailingStreet2"
              id="mailingStreet2"
              className="w-full"
              onChange={onChange}
              value={data.mailingStreet2}
            />
          </div>
          <div className="w-[18%]">
            <p className="m-0" style={{ marginBottom: 10 }}>
              <strong>City</strong>
            </p>
            <TextInput
              name="mailingCity"
              id="mailingCity"
              className="w-full"
              onChange={onChange}
              value={data.mailingCity}
            />
          </div>
          <div className="w-[10%]">
            <p className="m-0" style={{ marginBottom: 10 }}>
              <strong>State</strong>
            </p>
            <Select
              name="mailingState"
              id="mailingState"
              default={data.mailingState}
              style={{ marginBottom: 0 }}
              options={[
                { value: 'Alabama', label: 'AL' },
                { value: 'Alaska', label: 'AK' },
                { value: 'Arizona', label: 'AZ' },
                { value: 'Arkansas', label: 'AR' },
                { value: 'California', label: 'CA' },
                { value: 'Colorado', label: 'CO' },
                { value: 'Connecticut', label: 'CT' },
                { value: 'Delaware', label: 'DE' },
                { value: 'Florida', label: 'FL' },
                { value: 'Georgia', label: 'GA' },
                { value: 'Hawaii', label: 'HI' },
                { value: 'Idaho', label: 'ID' },
                { value: 'Illinois', label: 'IL' },
                { value: 'Indiana', label: 'IN' },
                { value: 'Iowa', label: 'IA' },
                { value: 'Kansas', label: 'KS' },
                { value: 'Kentucky', label: 'KY' },
                { value: 'Louisiana', label: 'LA' },
                { value: 'Maine', label: 'ME' },
                { value: 'Maryland', label: 'MD' },
                { value: 'Massachusetts', label: 'MA' },
                { value: 'Michigan', label: 'MI' },
                { value: 'Minnesota', label: 'MN' },
                { value: 'Mississippi', label: 'MS' },
                { value: 'Missouri', label: 'MO' },
                { value: 'Montana', label: 'MT' },
                { value: 'Nebraska', label: 'NE' },
                { value: 'Nevada', label: 'NV' },
                { value: 'New Hampshire', label: 'NH' },
                { value: 'New Jersey', label: 'NJ' },
                { value: 'New Mexico', label: 'NM' },
                { value: 'New York', label: 'NY' },
                { value: 'North Carolina', label: 'NC' },
                { value: 'North Dakota', label: 'ND' },
                { value: 'Ohio', label: 'OH' },
                { value: 'Oklahoma', label: 'OK' },
                { value: 'Oregon', label: 'OR' },
                { value: 'Pennsylvania', label: 'PA' },
                { value: 'Rhode Island', label: 'RI' },
                { value: 'South Carolina', label: 'SC' },
                { value: 'South Dakota', label: 'SD' },
                { value: 'Tennessee', label: 'TN' },
                { value: 'Texas', label: 'TX' },
                { value: 'Utah', label: 'UT' },
                { value: 'Vermont', label: 'VT' },
                { value: 'Virginia', label: 'VA' },
                { value: 'Washington', label: 'WA' },
                { value: 'West Virginia', label: 'WV' },
                { value: 'Wisconsin', label: 'WI' },
                { value: 'Wyoming', label: 'WY' },
              ]}
              containerClass="m-0"
              onChange={onChange}
            />
          </div>
          <div className="w-[10%]">
            <p className="m-0" style={{ marginBottom: 10 }}>
              <strong>ZIP</strong>
            </p>
            <TextInput
              name="mailingZip"
              id="mailingZip"
              className="w-full"
              onChange={onChange}
              value={data.mailingZip}
            />
          </div>
        </div>
        <Fieldset
          options={[
            'Business garaging address is same as mailing address',
          ]}
          name="sameBusinessAddress"
          type="checkbox"
          className="mt-4 flex items-center font-bold whitespace-nowrap"
          onChange={onChange}
          value={data.sameBusinessAddress}
        />
      </div>
      <div className="border rounded p-4 mb-8">
        <p className="text-xl">
          <strong>Business garaging address</strong>
        </p>
        <div className="flex justify-between w-full">
          <div className="w-[28%]">
            <p className="m-0" style={{ marginBottom: 10 }}>
              <strong>Address</strong>
            </p>
            <TextInput
              name="garageStreet"
              id="garageStreet"
              className="w-full"
              onChange={onChange}
              value={data.garageStreet}
            />
          </div>
          <div className="w-[28%]">
            <p className="m-0" style={{ marginBottom: 10 }}>
              <strong>Address Line 2</strong>
            </p>
            <TextInput
              name="garageStreet2"
              id="garageStreet2"
              className="w-full"
              onChange={onChange}
              value={data.garageStreet2}
            />
          </div>
          <div className="w-[18%]">
            <p className="m-0" style={{ marginBottom: 10 }}>
              <strong>City</strong>
            </p>
            <TextInput
              name="garageCity"
              id="garageCity"
              className="w-full"
              onChange={onChange}
              value={data.garageCity}
            />
          </div>
          <div className="w-[10%]">
            <p className="m-0">
              <strong>State</strong>
            </p>
            <Select
              name="garageState"
              id="garageState"
              default={data.garageState}
              style={{ marginBottom: 0 }}
              options={[
                { value: 'Alabama', label: 'AL' },
                { value: 'Alaska', label: 'AK' },
                { value: 'Arizona', label: 'AZ' },
                { value: 'Arkansas', label: 'AR' },
                { value: 'California', label: 'CA' },
                { value: 'Colorado', label: 'CO' },
                { value: 'Connecticut', label: 'CT' },
                { value: 'Delaware', label: 'DE' },
                { value: 'Florida', label: 'FL' },
                { value: 'Georgia', label: 'GA' },
                { value: 'Hawaii', label: 'HI' },
                { value: 'Idaho', label: 'ID' },
                { value: 'Illinois', label: 'IL' },
                { value: 'Indiana', label: 'IN' },
                { value: 'Iowa', label: 'IA' },
                { value: 'Kansas', label: 'KS' },
                { value: 'Kentucky', label: 'KY' },
                { value: 'Louisiana', label: 'LA' },
                { value: 'Maine', label: 'ME' },
                { value: 'Maryland', label: 'MD' },
                { value: 'Massachusetts', label: 'MA' },
                { value: 'Michigan', label: 'MI' },
                { value: 'Minnesota', label: 'MN' },
                { value: 'Mississippi', label: 'MS' },
                { value: 'Missouri', label: 'MO' },
                { value: 'Montana', label: 'MT' },
                { value: 'Nebraska', label: 'NE' },
                { value: 'Nevada', label: 'NV' },
                { value: 'New Hampshire', label: 'NH' },
                { value: 'New Jersey', label: 'NJ' },
                { value: 'New Mexico', label: 'NM' },
                { value: 'New York', label: 'NY' },
                { value: 'North Carolina', label: 'NC' },
                { value: 'North Dakota', label: 'ND' },
                { value: 'Ohio', label: 'OH' },
                { value: 'Oklahoma', label: 'OK' },
                { value: 'Oregon', label: 'OR' },
                { value: 'Pennsylvania', label: 'PA' },
                { value: 'Rhode Island', label: 'RI' },
                { value: 'South Carolina', label: 'SC' },
                { value: 'South Dakota', label: 'SD' },
                { value: 'Tennessee', label: 'TN' },
                { value: 'Texas', label: 'TX' },
                { value: 'Utah', label: 'UT' },
                { value: 'Vermont', label: 'VT' },
                { value: 'Virginia', label: 'VA' },
                { value: 'Washington', label: 'WA' },
                { value: 'West Virginia', label: 'WV' },
                { value: 'Wisconsin', label: 'WI' },
                { value: 'Wyoming', label: 'WY' },
              ]}
              containerClass="m-0"
              onChange={onChange}
            />
          </div>
          <div className="w-[10%]">
            <p className="m-0" style={{ marginBottom: 10 }}>
              <strong>ZIP</strong>
            </p>
            <TextInput
              name="garageZip"
              id="garageZip"
              className="w-full"
              onChange={onChange}
              value={data.garageZip}
            />
          </div>
        </div>
      </div>

      <p className="border-b pb-4 text-xl">
        <strong>Insured Contact Info</strong>
      </p>
      <div className="flex justify-between flex-wrap w-full mt-4">
        <div
          className={progressive ? 'w-[32%]' : 'w-[49%]'}
          style={{ marginTop: 15 }}
        >
          <p className="m-0">
            <strong>Email address</strong>
          </p>
          <EmailInput
            name="insuranceContactEmail"
            id="insuranceContactEmail"
            className="w-full"
            onChange={onChange}
            value={data.insuranceContactEmail}
          />
        </div>
        <div
          className={progressive ? 'w-[32%]' : 'w-[49%]'}
          style={{ marginTop: 15 }}
        >
          <p className="m-0">
            <strong>Phone</strong>
          </p>
          <PhoneInput
            name="insuranceContactPhone"
            for="insuranceContactPhone"
            className="w-full"
            onChange={onChange}
            value={data.insuranceContactPhone}
          />
        </div>
        {progressive && (
          <>
            <div className="w-[32%]">
              <p className="m-0">
                <strong>Date of birth (Progressive Only)</strong>
              </p>
              <DateInput
                name="insuredContactBirth"
                className="w-full"
                onChange={onChange}
                value={data.insuredContactBirth}
              />
            </div>
            <div className="w-full">
              <p className="m-0">
                <strong>Home address (Progressive Only)</strong>
              </p>
              <TextInput
                name="insuredContacHomeAddress"
                id="insuredContacHomeAddress"
                className="w-full"
                onChange={onChange}
                value={data.insuredContacHomeAddress}
              />
            </div>
          </>
        )}
      </div>
    </UnlimitedCard>
  );
}

function Vehicles(props) {
  const data = props.data;
  const setData = props.setData;
  const onChange = props.onChange;
  const context = useContext(ViewContext);
  const location = useLocation();

  useEffect(() => {
    if (
      location.state &&
      location.state.data &&
      location.state.data.company_id &&
      !location.state.data.quote_id
    ) {
      axios
        .get(
          `/api/vehicle/all?type=vehicle&company_id=${location.state.data.company_id}`
        )
        .then((r) => {
          const vehicles = [];
          var valueOfTrucks = 0;

          for (var i = 0; i < r.data.data.data.length; i++) {
            vehicles.push({
              type: r.data.data.data[i].type,
              id: r.data.data.data[i].id,
              vin: r.data.data.data[i].vin,
              model: r.data.data.data[i].model,
              year: r.data.data.data[i].year,
              make: r.data.data.data[i].make,
              classKey: getClass(r.data.data.data[i].class),
              bodyTypeKey: r.data.data.data[i].bodytype,
              value: JSON.stringify(r.data.data.data[i].stated_value),
              deductibleType: 'FollowsPolicy',
              deductible: '2500',
            });

            valueOfTrucks += r.data.data.data[i].stated_value;
          }

          setData((prevState) => {
            return {
              ...prevState,
              nbrOfTrucks: vehicles.length,
              valueOfTrucks,
              vehicles: vehicles,
            };
          });
        })
        .catch((err) => {
          console.log(err);

          context.notification.show(
            'Error on load company vehicles',
            'error',
            true
          );
        });
    }
  }, [location]);

  const addVehicle = (vehicleData) => {
    var temp_vehicles = data.vehicles;

    temp_vehicles.push({
      type: vehicleData.type,
      id: vehicleData.id,
      vin: vehicleData.vin,
      model: vehicleData.model,
      year: vehicleData.year,
      make: vehicleData.make,
      classKey: getClass(vehicleData.class),
      bodyTypeKey: vehicleData.bodytype,
      value: JSON.stringify(vehicleData.stated_value),
      deductibleType: 'FollowsPolicy',
      deductible: '2500',
      stated_value: vehicleData.stated_value,
    });

    setData((prevState) => {
      return {
        ...prevState,
        nbrOfTrucks: data.vehicles.length,
        valueOfTrucks:
          Number(data.valueOfTrucks) +
          Number(vehicleData.stated_value),
        vehicles: temp_vehicles,
      };
    });
  };

  const removeVehicle = (veh) => {
    setData((prevState) => {
      return {
        ...prevState,
        nbrOfTrucks: data.vehicles.length - 1,
        valueOfTrucks: data.valueOfTrucks - veh.value,
        vehicles: data.vehicles.filter(
          (item) => item.vin !== veh.vin
        ),
      };
    });
  };

  const handleInputChange = (name, value) => {
    const vehicleName = name.split('_')[0];
    const vehicleIndex = name.split('_')[1];

    setData((prevState) => {
      const newItems = [...prevState.vehicles];
      newItems[vehicleIndex] = {
        ...newItems[vehicleIndex],
        [vehicleName]: value,
      };
      return {
        ...prevState,
        vehicles: newItems,
      };
    });
  };

  const [needUpdate, setNeedUpdate] = useState([]);
  const { setModal } = useContext(ModalContext);

  return (
    <UnlimitedCard className="mb-6" id="9">
      <header className="w-full pb-4 mb-4 bg-transparent border-b-2 border-slate-300 flex justify-between">
        <h2 className="capitalize text-xl font-semibold pt-4">
          Vehicles
        </h2>
        <div className="flex gap-4">
          <BlackButton
            color="bluesign"
            className="text-sm"
            text="Add Vehicle"
            action={() => {
              setModal({
                name: 'options',
                data: {
                  title:
                    'Create a new vehicle or choose from your existing vehicles?',
                  options: [
                    {
                      label: 'Select Existing',
                      action: () =>
                        setModal({
                          name: 'choose',
                          stage: 1,
                          data: {
                            type: 'vehicle',
                            company_id:
                              location.state.data.company_id,
                          },
                          currentList: data.vehicles,
                          action: (data) => addVehicle(data),
                        }),
                    },
                    {
                      label: 'Create New Vehicle',
                      action: () =>
                        setModal({
                          name: 'vehicle_modal',
                          stage: 1,
                          data: {
                            type: 'vehicle',
                            company_id:
                              location.state.data.company_id,
                          },
                          mode: 'run_quote',
                          action: (data) => addVehicle(data),
                        }),
                      featured: true,
                    },
                  ],
                },
              });
            }}
          />
        </div>
      </header>
      {data.vehicles && data.vehicles.length > 0 && (
        <div>
          {data.vehicles.map((vehicle, index) => {
            return (
              <div
                className="flex items-end gap-4 w-full"
                key={vehicle.vin}
                style={{ marginBottom: 10 }}
              >
                <p className="mb-4 font-bold">{index + 1}</p>
                <div className="w-[10%]">
                  <NumberInput
                    label="Year"
                    name={`year_${index}`}
                    value={vehicle.year}
                    containerClass="w-[10%]"
                    className="w-full text-sm"
                    onChange={(name, value) => {
                      if (!needUpdate.includes(index)) {
                        needUpdate.push(index);
                      }
                      handleInputChange(name, value);
                    }}
                  />
                </div>
                <div className="w-[10%]">
                  <TextInput
                    label="Make"
                    name={`make_${index}`}
                    id={`make_${index}`}
                    value={vehicle.make}
                    containerClass="w-[18%]"
                    className="w-full text-sm"
                    onChange={(name, value) => {
                      if (!needUpdate.includes(index)) {
                        needUpdate.push(index);
                      }
                      handleInputChange(name, value);
                    }}
                  />
                </div>
                <div className="w-[10%]">
                  <TextInput
                    label="Model"
                    id={`model_${index}`}
                    name={`model_${index}`}
                    value={vehicle.model}
                    containerClass="w-[18%]"
                    className="w-full text-sm"
                    onChange={(name, value) => {
                      if (!needUpdate.includes(index)) {
                        needUpdate.push(index);
                      }
                      handleInputChange(name, value);
                    }}
                  />
                </div>
                <div className="w-[10%]">
                  <TextInput
                    label="VIN"
                    name={`vin_${index}`}
                    value={vehicle.vin}
                    containerClass="w-[18%]"
                    className="w-full text-sm"
                    onChange={(name, value) => {
                      if (!needUpdate.includes(index)) {
                        needUpdate.push(index);
                      }
                      handleInputChange(name, value);
                    }}
                  />
                </div>
                <div className="w-[10%]">
                  <MoneyInput
                    label="Value"
                    name={`value_${index}`}
                    value={vehicle.value}
                    containerClass="w-[18%]"
                    className="w-full text-sm"
                    onChange={(name, value) => {
                      if (!needUpdate.includes(index)) {
                        needUpdate.push(index);
                      }
                      handleInputChange(name, value);
                    }}
                  />
                </div>
                <div className="w-[15%]">
                  <p className="m-0">
                    <span>Body Type</span>
                  </p>
                  <Select
                    name={`bodyTypeKey_${index}`}
                    options={vehiclesBodytype}
                    onChange={(name, value) => {
                      if (!needUpdate.includes(index)) {
                        needUpdate.push(index);
                      }
                      handleInputChange(name, value);
                    }}
                    value={vehicle.bodyTypeKey}
                    default={
                      vehiclesBodytype.find(
                        (bt) => bt.value === vehicle.bodyTypeKey
                      )
                        ? vehiclesBodytype.find(
                            (bt) => bt.value === vehicle.bodyTypeKey
                          ).value
                        : trailersBodytype.find(
                            (bt) => bt.value === vehicle.bodyTypeKey
                          ).value
                    }
                  />
                </div>
                <div className="w-[15%]">
                  <p className="m-0">
                    <span>Class</span>
                  </p>
                  <Select
                    name={`classKey_${index}`}
                    options={classOptions}
                    onChange={(name, value) => {
                      if (!needUpdate.includes(index)) {
                        needUpdate.push(index);
                      }
                      handleInputChange(name, value);
                    }}
                    value={vehicle.classKey}
                    default={
                      classOptions.find(
                        (bt) =>
                          bt.value === getClassIndex(vehicle.classKey)
                      ).value
                    }
                  />
                </div>
                <div
                  style={{
                    width: '300px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                  }}
                >
                  {needUpdate.includes(index) && (
                    <div
                      style={{
                        background: 'red',
                        color: '#fff',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        padding: 10,
                        borderRadius: 5,
                        cursor: 'pointer',
                        margin: 10,
                      }}
                      onClick={() => {
                        axios
                          .patch(
                            '/api/vehicle/' + data.vehicles[index].id,
                            {
                              year: data.vehicles[index].year,
                              make: data.vehicles[index].make,
                              model: data.vehicles[index].model,
                              vin: data.vehicles[index].vin,
                              stated_value:
                                data.vehicles[index].value,
                              bodytype:
                                data.vehicles[index].bodyTypeKey,
                              class: data.vehicles[index].class,
                            }
                          )
                          .then((res) => {
                            needUpdate.splice(
                              needUpdate.indexOf(index),
                              1
                            );

                            context.notification.show(
                              'Vehicle updated',
                              'success',
                              true
                            );
                          })
                          .catch(() => {
                            context.notification.show(
                              'Failed to update vehicle',
                              'error',
                              true
                            );
                          });
                      }}
                    >
                      Update Vehicle
                    </div>
                  )}
                  <IconedButton
                    size="50px"
                    color="#d32425"
                    textColor="white"
                    iconWithoutMargin
                    icon="minus-square"
                    action={() => removeVehicle(vehicle)}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </UnlimitedCard>
  );
}

function Trailers(props) {
  const data = props.data;
  const setData = props.setData;
  const context = useContext(ViewContext);
  const location = useLocation();

  useEffect(() => {
    if (
      location.state &&
      location.state.data &&
      location.state.data.company_id &&
      !location.state.data.quote_id
    ) {
      axios
        .get(
          `/api/vehicle/all?type=trailer&company_id=${location.state.data.company_id}`
        )
        .then((r) => {
          const trailers = [];
          var valueOfTrailers = 0;

          for (var i = 0; i < r.data.data.data.length; i++) {
            trailers.push({
              id: r.data.data.data[i].id,
              vin: r.data.data.data[i].vin,
              model: r.data.data.data[i].model,
              year: r.data.data.data[i].year,
              make: r.data.data.data[i].make,
              value: JSON.stringify(r.data.data.data[i].stated_value),
              bodyTypeKey: r.data.data.data[i].bodytype,
              deductibleType: 'FollowsPolicy',
              deductible: '1500',
            });

            valueOfTrailers += r.data.data.data[i].stated_value;
          }

          setData((prevState) => {
            return {
              ...prevState,
              nbrOfTrailers: trailers.length,
              valueOfTrailers,
              trailers: trailers,
            };
          });
        })
        .catch((err) => {
          console.log(err);

          context.notification.show(
            'Error on load company vehicles',
            'error',
            true
          );
        });
    }
  }, [location]);

  const addTrailer = (trailerData) => {
    var temp_trailers = data.trailers;

    temp_trailers.push({
      id: trailerData.id,
      vin: trailerData.vin,
      model: trailerData.model,
      year: trailerData.year,
      make: trailerData.make,
      bodyTypeKey: trailerData.bodytype,
      value: JSON.stringify(trailerData.stated_value),
      deductibleType: 'FollowsPolicy',
      deductible: '1500',
    });

    setData((prevState) => {
      return {
        ...prevState,
        nbrOfTrailers: data.trailers.length,
        valueOfTrailers:
          Number(data.valueOfTrailers) +
          Number(trailerData.stated_value),
        trailers: temp_trailers,
      };
    });
  };

  const removeTrailer = (veh) => {
    setData((prevState) => {
      return {
        ...prevState,
        nbrOfTrailers: data.trailers.length - 1,
        valueOfTrailers: data.valueOfTrailers - veh.value,
        trailers: data.trailers.filter(
          (item) => item.vin !== veh.vin
        ),
      };
    });
  };

  const handleInputChange = (name, value) => {
    const vehicleName = name.split('_')[0];
    const vehicleIndex = name.split('_')[1];
    setData((prevState) => {
      const newItems = [...prevState.trailers];
      newItems[vehicleIndex] = {
        ...newItems[vehicleIndex],
        [vehicleName]: value,
      };
      return {
        ...prevState,
        trailers: newItems,
      };
    });
  };

  const [needUpdate, setNeedUpdate] = useState([]);
  const { setModal } = useContext(ModalContext);

  return (
    <UnlimitedCard className="mb-6" id="10">
      <header className="w-full pb-4 mb-4 bg-transparent border-b-2 border-slate-300 flex justify-between">
        <h2 className="capitalize text-xl font-semibold pt-4">
          Trailers
        </h2>
        <div className="flex gap-4">
          <BlackButton
            color="bluesign"
            className="text-sm"
            text="Add Trailer"
            action={() => {
              setModal({
                name: 'options',
                data: {
                  title:
                    'Create a new trailer or choose from your existing trailers?',
                  options: [
                    {
                      label: 'Select Existing',
                      action: () =>
                        setModal({
                          name: 'choose',
                          stage: 1,
                          data: {
                            type: 'trailer',
                            company_id:
                              location.state.data.company_id,
                          },
                          currentList: data.trailers,
                          action: (data) => addTrailer(data),
                        }),
                    },
                    {
                      label: 'Create New Vehicle',
                      action: () =>
                        setModal({
                          name: 'vehicle_modal',
                          stage: 1,
                          data: {
                            type: 'trailer',
                            company_id:
                              location.state.data.company_id,
                          },
                          mode: 'run_quote',
                          action: (data) => addTrailer(data),
                        }),
                      featured: true,
                    },
                  ],
                },
              });
            }}
          />
        </div>
      </header>
      {data.trailers && data.trailers.length > 0 && (
        <div>
          {data.trailers.map((vehicle, index) => (
            <div
              className="flex items-end gap-4 w-full"
              key={vehicle.vin}
            >
              <p className="mb-4 font-bold">{index + 1}</p>
              <div className="w-[10%]">
                <NumberInput
                  label="Year"
                  name={`year_${index}`}
                  value={vehicle.year}
                  containerClass="w-[10%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[10%]">
                <TextInput
                  label="Make"
                  name={`make_${index}`}
                  id={`make_${index}`}
                  value={vehicle.make}
                  containerClass="w-[18%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[10%]">
                <TextInput
                  label="Model"
                  id={`model_${index}`}
                  name={`model_${index}`}
                  value={vehicle.model}
                  containerClass="w-[18%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[10%]">
                <TextInput
                  label="VIN"
                  id={`vin_${index}`}
                  name={`vin_${index}`}
                  value={vehicle.vin}
                  containerClass="w-[18%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[10%]">
                <MoneyInput
                  label="Value"
                  name={`value_${index}`}
                  value={vehicle.value}
                  containerClass="w-[18%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[15%]">
                <p className="m-0">
                  <span>Body Type</span>
                </p>
                <Select
                  name={`bodyTypeKey_${index}`}
                  options={trailersBodytype}
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                  value={vehicle.bodyTypeKey}
                  default={
                    trailersBodytype.find(
                      (bt) => bt.value === vehicle.bodyTypeKey
                    ).value
                  }
                />
              </div>
              <div
                style={{
                  width: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}
              >
                {needUpdate.includes(index) && (
                  <div
                    style={{
                      background: 'red',
                      color: '#fff',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      padding: 10,
                      borderRadius: 5,
                      cursor: 'pointer',
                      margin: 10,
                    }}
                    onClick={() => {
                      axios
                        .patch(
                          '/api/vehicle/' + data.trailers[index].id,
                          {
                            year: data.trailers[index].year,
                            make: data.trailers[index].make,
                            model: data.trailers[index].model,
                            vin: data.trailers[index].vin,
                            stated_value: data.trailers[index].value,
                            bodytype:
                              data.trailers[index].bodyTypeKey,
                          }
                        )
                        .then((res) => {
                          needUpdate.splice(
                            needUpdate.indexOf(index),
                            1
                          );

                          context.notification.show(
                            'Trailer updated',
                            'success',
                            true
                          );
                        })
                        .catch(() => {
                          context.notification.show(
                            'Failed to update trailer',
                            'error',
                            true
                          );
                        });
                    }}
                  >
                    Update Trailer
                  </div>
                )}
                <IconedButton
                  size="50px"
                  color="#d32425"
                  textColor="white"
                  iconWithoutMargin
                  icon="minus-square"
                  action={() => removeTrailer(vehicle)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </UnlimitedCard>
  );
}

function Drivers(props) {
  const data = props.data;
  const setData = props.setData;
  const context = useContext(ViewContext);
  const location = useLocation();
  const helper = new DateUtils();

  const addDriver = (driverData) => {
    var temp_drivers = data.drivers;

    if (!driverData) return;

    temp_drivers.push({
      id: driverData.id,
      firstName: driverData.name.split(' ')[0],
      lastName: driverData.name.split(' ')[1],
      dateOfBirth: helper.isoDate(
        new Date(driverData.date_of_birth).toISOString()
      ),
      dateOfHire: helper.isoDate(
        new Date(driverData.date_of_hire).toISOString()
      ),
      licenseNumber: driverData.license_number,
      licenseState: driverData.license_state,
      yearsExperience: driverData.years_of_experience,
      accidents: driverData.accidents,
      violations: driverData.violations,
      suspensions: driverData.suspensions,
      eligibility: 'Covered',
    });

    setData((prevState) => {
      return {
        ...prevState,
        drivers: temp_drivers,
      };
    });
  };

  useEffect(() => {
    if (
      location.state &&
      location.state.data &&
      location.state.data.company_id &&
      !location.state.data.quote_id
    ) {
      axios
        .get(
          `/api/driver/all?company_id=${location.state.data.company_id}`
        )
        .then((r) => {
          const drivers = [];

          for (var i = 0; i < r.data.data.data.length; i++) {
            const license_state = r.data.data.data[i].license_state;

            drivers.push({
              id: r.data.data.data[i].id,
              firstName: r.data.data.data[i].name.split(' ')[0],
              lastName: r.data.data.data[i].name.split(' ')[1],
              dateOfBirth: helper.isoDate(
                r.data.data.data[i].date_of_birth
              ),
              dateOfHire: helper.isoDate(
                r.data.data.data[i].date_of_hire
              ),
              licenseNumber: r.data.data.data[i].license_number,
              licenseState: stateOptions.find(
                (item) => item.value === license_state
              )
                ? stateOptions.find(
                    (item) => item.value === license_state
                  ).value
                : stateOptions.find(
                    (item) => item.label === license_state
                  ).value,
              yearsExperience:
                r.data.data.data[i].years_of_experience,
              accidents: r.data.data.data[i].accidents,
              violations: r.data.data.data[i].violations,
              suspensions: r.data.data.data[i].suspensions,
              eligibility: 'Covered',
            });
          }

          setData((prevState) => {
            return {
              ...prevState,
              drivers: drivers,
            };
          });
        })
        .catch((err) => {
          console.log(err);

          context.notification.show(
            'Error on load company drivers',
            'error',
            true
          );
        });
    }
  }, [location.state]);

  const removeDriver = (id) => {
    setData((prevState) => {
      return {
        ...prevState,
        drivers: data.drivers.filter((item) => item.id !== id),
      };
    });
  };

  const handleInputChange = (name, value) => {
    const driverName = name.split('_')[0];
    const driverIndex = name.split('_')[1];

    if (name.includes('accidents') && value < 0) {
      return;
    }

    if (name.includes('violations') && value < 0) {
      return;
    }

    if (name.includes('suspensions') && value < 0) {
      return;
    }

    setData((prevState) => {
      const newItems = [...prevState.drivers];
      newItems[driverIndex] = {
        ...newItems[driverIndex],
        [driverName]: value,
      };
      return {
        ...prevState,
        drivers: newItems,
      };
    });
  };

  const { setModal } = useContext(ModalContext);

  const [needUpdate, setNeedUpdate] = useState([]);

  return (
    <UnlimitedCard className="mb-6" id="11">
      <header className="w-full pb-4 mb-4 bg-transparent border-b-2 border-slate-300 flex justify-between">
        <h2 className="capitalize text-xl font-semibold pt-4">
          Drivers
        </h2>
        <div className="flex gap-4">
          <BlackButton
            color="bluesign"
            className="text-sm"
            text="Add Driver"
            action={() => {
              setModal({
                name: 'options',
                data: {
                  title:
                    'Create a new driver or choose from your existing drivers?',
                  options: [
                    {
                      label: 'Select Existing',
                      action: () =>
                        setModal({
                          name: 'choose',
                          stage: 1,
                          data: {
                            type: 'driver',
                            company_id:
                              location.state.data.company_id,
                          },
                          currentList: data.drivers,
                          action: (data) => addDriver(data),
                        }),
                    },
                    {
                      label: 'Create New Driver',
                      action: () =>
                        setModal({
                          name: 'driver_modal',
                          mode: 'run_quote',
                          data: {
                            company_id:
                              location.state.data.company_id,
                          },
                          action: (data) => addDriver(data),
                        }),
                      featured: true,
                    },
                  ],
                },
              });
            }}
          />
        </div>
      </header>
      {data.drivers && data.drivers.length > 0 && (
        <div>
          {data.drivers.map((driver, index) => (
            <div
              className="flex items-end gap-4 w-full mt-4"
              key={driver.id}
            >
              <p className=" font-bold">{index + 1}</p>
              <div className="w-[12%]">
                <TextInput
                  label="First Name"
                  id={`firstName_${index}`}
                  name={`firstName_${index}`}
                  value={driver.firstName}
                  containerClass="w-[11%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[12%]">
                <TextInput
                  label="Last Name"
                  id={`lastName_${index}`}
                  name={`lastName_${index}`}
                  value={driver.lastName}
                  containerClass="w-[11%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[15%]">
                <TextInput
                  label="Date of Birth"
                  id={`dateOfBirth_${index}`}
                  name={`dateOfBirth_${index}`}
                  value={driver.dateOfBirth}
                  containerClass="w-[11%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[15%]">
                <TextInput
                  label="Date of Hire"
                  id={`dateOfHire_${index}`}
                  name={`dateOfHire_${index}`}
                  value={driver.dateOfHire}
                  containerClass="w-[11%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[13%]">
                <NumberInput
                  label="Years of Experience"
                  id={`yearsExperience_${index}`}
                  name={`yearsExperience_${index}`}
                  value={driver.yearsExperience}
                  containerClass="w-[22%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[10%]">
                <TextInput
                  label="License"
                  id={`licenseNumber_${index}`}
                  name={`licenseNumber_${index}`}
                  value={driver.licenseNumber}
                  containerClass="w-[22%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[10%]">
                <Select
                  label="State"
                  name={`licenseState_${index}`}
                  options={[
                    { value: 'Alabama', label: 'AL' },
                    { value: 'Alaska', label: 'AK' },
                    { value: 'Arizona', label: 'AZ' },
                    { value: 'Arkansas', label: 'AR' },
                    { value: 'California', label: 'CA' },
                    { value: 'Colorado', label: 'CO' },
                    { value: 'Connecticut', label: 'CT' },
                    { value: 'Delaware', label: 'DE' },
                    { value: 'Florida', label: 'FL' },
                    { value: 'Georgia', label: 'GA' },
                    { value: 'Hawaii', label: 'HI' },
                    { value: 'Idaho', label: 'ID' },
                    { value: 'Illinois', label: 'IL' },
                    { value: 'Indiana', label: 'IN' },
                    { value: 'Iowa', label: 'IA' },
                    { value: 'Kansas', label: 'KS' },
                    { value: 'Kentucky', label: 'KY' },
                    { value: 'Louisiana', label: 'LA' },
                    { value: 'Maine', label: 'ME' },
                    { value: 'Maryland', label: 'MD' },
                    { value: 'Massachusetts', label: 'MA' },
                    { value: 'Michigan', label: 'MI' },
                    { value: 'Minnesota', label: 'MN' },
                    { value: 'Mississippi', label: 'MS' },
                    { value: 'Missouri', label: 'MO' },
                    { value: 'Montana', label: 'MT' },
                    { value: 'Nebraska', label: 'NE' },
                    { value: 'Nevada', label: 'NV' },
                    { value: 'New Hampshire', label: 'NH' },
                    { value: 'New Jersey', label: 'NJ' },
                    { value: 'New Mexico', label: 'NM' },
                    { value: 'New York', label: 'NY' },
                    { value: 'North Carolina', label: 'NC' },
                    { value: 'North Dakota', label: 'ND' },
                    { value: 'Ohio', label: 'OH' },
                    { value: 'Oklahoma', label: 'OK' },
                    { value: 'Oregon', label: 'OR' },
                    { value: 'Pennsylvania', label: 'PA' },
                    { value: 'Rhode Island', label: 'RI' },
                    { value: 'South Carolina', label: 'SC' },
                    { value: 'South Dakota', label: 'SD' },
                    { value: 'Tennessee', label: 'TN' },
                    { value: 'Texas', label: 'TX' },
                    { value: 'Utah', label: 'UT' },
                    { value: 'Vermont', label: 'VT' },
                    { value: 'Virginia', label: 'VA' },
                    { value: 'Washington', label: 'WA' },
                    { value: 'West Virginia', label: 'WV' },
                    { value: 'Wisconsin', label: 'WI' },
                    { value: 'Wyoming', label: 'WY' },
                  ]}
                  default={driver.licenseState}
                  className="w-[100px] text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                  style={{ width: '100%' }}
                />
              </div>
              <div className="w-[10%]">
                <NumberInput
                  label="Accidents"
                  id={`accidents_${index}`}
                  name={`accidents_${index}`}
                  value={driver.accidents}
                  containerClass="w-[22%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[10%]">
                <NumberInput
                  label="Violations"
                  id={`violations_${index}`}
                  name={`violations_${index}`}
                  value={driver.violations}
                  containerClass="w-[22%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>
              <div className="w-[10%]">
                <NumberInput
                  label="Suspensions"
                  id={`suspensions_${index}`}
                  name={`suspensions_${index}`}
                  value={driver.suspensions}
                  containerClass="w-[22%]"
                  className="w-full text-sm"
                  onChange={(name, value) => {
                    if (!needUpdate.includes(index)) {
                      needUpdate.push(index);
                    }
                    handleInputChange(name, value);
                  }}
                />
              </div>

              <div
                style={{
                  width: '300px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}
              >
                {needUpdate.includes(index) && (
                  <div
                    style={{
                      background: 'red',
                      color: '#fff',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      padding: 10,
                      borderRadius: 5,
                      cursor: 'pointer',
                      margin: 10,
                    }}
                    onClick={() => {
                      axios
                        .patch(
                          '/api/driver/' + data.drivers[index].id,
                          {
                            name:
                              data.drivers[index].firstName +
                              ' ' +
                              data.drivers[index].lastName,
                            license_number:
                              data.drivers[index].licenseNumber,
                            date_of_birth:
                              data.drivers[index].dateOfBirth,
                            date_of_hire:
                              data.drivers[index].dateOfHire,
                            license_state:
                              data.drivers[index].licenseState,
                            years_of_experience:
                              data.drivers[index].yearsExperience,
                            accidents: data.drivers[index].accidents,
                            violations:
                              data.drivers[index].violations,
                            suspensions:
                              data.drivers[index].suspensions,
                          }
                        )
                        .then((res) => {
                          needUpdate.splice(
                            needUpdate.indexOf(index),
                            1
                          );

                          context.notification.show(
                            'Driver updated',
                            'success',
                            true
                          );
                        })
                        .catch(() => {
                          context.notification.show(
                            'Failed to update driver',
                            'error',
                            true
                          );
                        });
                    }}
                  >
                    Update Driver
                  </div>
                )}
                <IconedButton
                  size="50px"
                  color="#d32425"
                  textColor="white"
                  iconWithoutMargin
                  icon="minus-square"
                  action={() => removeDriver(driver.id)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </UnlimitedCard>
  );
}
